var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.745,
    height: 37.745,
    viewBox: "0 0 37.745 37.745",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close",
    transform: "translate(-3.375 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M26.47,24.421,21.689,19.64l4.782-4.782a1.45,1.45,0,0,0-2.051-2.051l-4.782,4.782-4.782-4.782a1.45,1.45,0,0,0-2.051,2.051l4.782,4.782-4.782,4.782a1.4,1.4,0,0,0,0,2.051,1.44,1.44,0,0,0,2.051,0l4.782-4.782,4.782,4.782a1.457,1.457,0,0,0,2.051,0A1.44,1.44,0,0,0,26.47,24.421Z",
    transform: "translate(2.609 2.608)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M22.247,5.916A16.326,16.326,0,1,1,10.7,10.7a16.224,16.224,0,0,1,11.55-4.782m0-2.541A18.872,18.872,0,1,0,41.12,22.247,18.87,18.87,0,0,0,22.247,3.375Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWhite);
export default __webpack_public_path__ + "static/media/close_white.0b3fe8ee8956896781cc73adac1c74a7.svg";
export { ForwardRef as ReactComponent };